
export const environment = {
  production: true,
  API_PATH: 'https://apigateway.airportr.com/',
  subscriptionKey: '87a5c7349963434090696fdf93f103f8',
  alliesAPI: 'PCWS2-MR8MH-WBMMX-LBXPW',
  envName: 'prod',
  paymentMgmUrl: 'https://tag.mention-me.com/api/v2/refereefind/mmfcd158f0?implementation=link&situation=checkout&locale=en_GB',
  completeMgmUrl: 'https://tag.mention-me.com/api/v2/referreroffer/mmfcd158f0?situation=postpurchase&order_currency=GBP&locale=en_GB',
  rewardsMgmUrl: 'https://tag.mention-me.com/api/v2/referreroffer/mmfcd158f0',
  reactQuoteForm: 'https://portrlivecdnstorage.blob.core.windows.net/assets/booking-pod-live.js?v=106&sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D',
  bookingPodGlobalFns: 'https://portrlivecdnstorage.blob.core.windows.net/assets/portr-global-events.js?sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D',
  portrCRMPopups: 'https://portrlivecdnstorage.blob.core.windows.net/assets/portr-crm-popups-live.js?v=1&sp=r&st=2023-07-31T13:28:56Z&se=2028-01-08T22:28:56Z&spr=https&sv=2022-11-02&sr=c&sig=Kd1nL6EpQREvU2OVv8Znrpx0iNVvzJNgGsI%2Big%2Bixo0%3D',
  fullUrl: 'https://booking.airportr.com/',
  trackUrl: 'https://track.airportr.com/',
  azureInsightsKey: 'cf15944d-96de-4d2e-93a0-2c6817c24fd7',
  bookingKeyStart: '10001|',
  bookingKey: 'C606B3E1874EB04408DF9A99B2FA944085DD7023BBBAE14997C470C488DAC3D2DA2469E62332317' +
  'C647F7BF31B26DCB4B51CBA316A2BF9A5D616BD2A36D826039F8A8F3723286D9874DF46B05DFB11F' +
  '75018CCBD6BCB1E8055C867F8BA67A059C1556CC9017890F62AAF65913F8DA32EF6F840DA5C1DEC7' +
  'E2FF57F4661A1CF50D9987BE079AA3C725DD2801B610CAB3F37EB09B88AD68106EEB2C10082C47C5' +
  'FE680AB3D50F0BBA2EC877CADE361657018ACA7892BA7B18ABC1BC1FFC68DB06A215BE122D3D9C8C' +
  '47A51D26C7F323FA01B113EDF6ABB9B6D9B1E1CA13130B36783F110E4A2325420C13D65E0FBCAC07' +
  '6E992144234F24F4A06291C6929E0EE87',
  abEnv: 'green',
  homeURL: 'https://airportr.com/',
  milesLoginURL: 'https://api.miles-and-more.com/oauth2/authorize?response_type=code&scope=urn:milesandmore:user:addresses:primary:v1:read%20urn:milesandmore:user:emails:primary:v1:read%20urn:milesandmore:member:awardmiles:v1:read%20urn:milesandmore:user:profile:v1:read%20urn:milesandmore:user:phonenumbers:primary:v1:read%20urn:milesandmore:user:birthday:v1:read%20urn:milesandmore:user:id:v1&view=login.html&client_id=XStyIYMX4pVfMcFDxubA37ALL0hU71PH',
  gPayMerchantId: 'BCR2DN4T5HDLJQJT',
  gPayMerchantName: 'PortrLtd',
  slotNumber: 'a',
  slotVersion: '1.0.0',
  addressyAPIKey: 'GT89-ZY71-AZ19-PN12',
  amendBookingURL: 'https://bookingv2.airportr.com/',
  googleAPIKey: 'AIzaSyCyW4uJWHpGOMJZn_81xm-_PkvY_NH-Dm4',
  mobileAPIKey: 'bc5fa227fd1e4a6db0f1e3987c6e0008',
};
